import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { Grid } from '@material-ui/core'
import AdminPage from '../../../admin/shared/AdminPage'
import OperationalTable from '../../../../organisms/OperationalTable'
import Loading from '../../../../molecules/Loading'
import EmptySection from '../../../../atoms/EmptySection'
import FlexRow from '../../../../molecules/FlexRow'
import SydButton from '../../../../commonDesign/Button'
import { provisionedTargets } from '../../../../../api/integrations'
import CreateProvisionedTargetDialog from './CreateProvisionedTargetDialog'

function ProvisionedTargetList ({ root }) {
  const { data, isLoading } = provisionedTargets.useListProvisionedTargetTables()
  const targets = data?.result || []
  const [createOpen, setCreateOpen] = useState(false)
  const history = useHistory()

  const handleCreateComplete = useCallback((result) => {
    setCreateOpen(false)
    const insertId = result?.result?.id
    if (insertId) {
      history.push(`${root}/integrator/targets/${insertId}`)
    }
  }, [history, root])

  const handleRowClick = useCallback((row) => {
    history.push(`${root}/integrator/targets/${row.original.provisionedTargetTableId}`)
  }, [history, root])

  const columns = [
    { id: 'provisionedTargetTableId', accessor: 'provisionedTargetTableId', Header: 'ID' },
    { id: 'tableName', accessor: 'tableName', Header: 'Table Name' },
    { id: 'domain', accessor: 'domain', Header: 'Domain', Cell: ({ value }) => value || '—' },
    { id: 'description', accessor: 'description', Header: 'Description', Cell: ({ value }) => value || '—' },
    {
      id: 'isLocked',
      accessor: 'isLocked',
      Header: 'Locked',
      // eslint-disable-next-line react/prop-types
      Cell: ({ value }) => (value ? 'Yes' : 'No')
    },
    { id: 'createdDate', accessor: 'createdDate', Header: 'Created' }
  ]

  if (isLoading) {
    return (
      <AdminPage>
        <Loading />
      </AdminPage>
    )
  }

  if (!targets.length && !isLoading) {
    return (
      <AdminPage>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <EmptySection
              title='No Provisioned Target Tables Yet'
              description={(
                <FlexRow>
                  <SydButton
                    variant='primary'
                    size='lg'
                    icon='add'
                    onClick={() => setCreateOpen(true)}
                  >
                    Create Your First Provisioned Target
                  </SydButton>
                </FlexRow>
              )}
            />
          </Grid>
        </Grid>

        <CreateProvisionedTargetDialog
          open={createOpen}
          onClose={() => setCreateOpen(false)}
          onComplete={handleCreateComplete}
        />
      </AdminPage>
    )
  }

  return (
    <AdminPage>
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h1>Provisioned Target Tables</h1>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <SydButton onClick={() => setCreateOpen(true)} icon='add'>
              Create Target
            </SydButton>
          </div>
        </Grid>
        <Grid item xs={12}>
          <OperationalTable
            variant='v2'
            columns={columns}
            data={targets}
            isLoading={isLoading}
            defaultSort={[{ id: 'tableName', desc: false }]}
            onRowClick={handleRowClick}
          />
        </Grid>
      </Grid>

      <CreateProvisionedTargetDialog
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        onComplete={handleCreateComplete}
      />
    </AdminPage>
  )
}

ProvisionedTargetList.propTypes = {
  root: PropTypes.any
}

export default ProvisionedTargetList
